module.exports = __webpack_public_path__ + "img/banner_cfr_map.4b846b47.png";